import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ui-dropdown" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "ui-dropdown__single"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "ui-dropdown__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_chevron_down = _resolveComponent("icon-chevron-down")!
  const _component_ui_click_outside = _resolveComponent("ui-click-outside")!
  const _component_ui_dropdown = _resolveComponent("ui-dropdown")!

  return (_openBlock(), _createBlock(_component_ui_dropdown, null, {
    default: _withCtx(({ isActive, toggle, hide }) => [
      _createVNode(_component_ui_click_outside, { onTrigger: hide }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "ui-dropdown__element",
              onClick: _withModifiers(toggle, ["prevent"])
            }, [
              ($setup.currentItem)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($setup.currentItem.label), 1))
                : _createCommentVNode("", true),
              _createElementVNode("span", {
                class: _normalizeClass(["ui-dropdown__icon", { 'is-active': isActive }])
              }, [
                _createVNode(_component_icon_chevron_down)
              ], 2)
            ], 8, _hoisted_2),
            _createElementVNode("div", {
              class: _normalizeClass(["ui-dropdown__wrapper", { 'is-active': isActive }])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredItems, (item) => {
                return (_openBlock(), _createElementBlock("a", {
                  class: "ui-dropdown__item",
                  href: $setup.getLanguageLink(item.value)
                }, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(item.label), 1)
                ], 8, _hoisted_4))
              }), 256))
            ], 2)
          ])
        ]),
        _: 2
      }, 1032, ["onTrigger"])
    ]),
    _: 1
  }))
}